import Vue from 'vue';
import JoinFormApp from './JoinFormApp.vue';
import Vuelidate from 'vuelidate';
import VueTelInput from 'vue-tel-input'
 
Vue.use(VueTelInput)

Vue.use(Vuelidate);

Vue.config.productionTip = false

new Vue({
  render: h => h(JoinFormApp),
}).$mount('#joinFormApp')